(() => {
  const SELECTED_CLASS = 'is-selected';

  function initialise(root) {
    if (!root || root.dataset.cmReady === 'true') return;
    root.dataset.cmReady = 'true';

    const price = root.querySelector('[data-cm-price]');
    const addButton = root.querySelector('[data-cm-add]');
    const mobileButton = root.querySelector('[data-cm-mobile]');
    const status = root.querySelector('[data-cm-status]');
    const secondField = root.querySelector('[data-cm-second-field]');
    const mainImage = root.querySelector('[data-cm-main-image]');
    const imageLabel = root.querySelector('[data-cm-image-label]');
    const firstName = root.querySelector('[data-cm-first-name]');
    const secondName = root.querySelector('[data-cm-second-name]');
    const packButtons = [...root.querySelectorAll('[data-cm-pack]')];
    const firstColours = [...root.querySelectorAll('[data-cm-first-swatches] [data-cm-color]')];
    const secondColours = [...root.querySelectorAll('[data-cm-second-swatches] [data-cm-color]')];
    const singlePrice = price?.textContent.trim() || '$20';
    const pairPrice = '$38';
    let pack = 'single';
    let firstColour = firstColours.find((button) => button.classList.contains(SELECTED_CLASS)) || firstColours[0];
    let secondColour = secondColours.find((button) => button.classList.contains(SELECTED_CLASS)) || secondColours[0];

    const setPressed = (buttons, active) => {
      buttons.forEach((button) => {
        const selected = button === active;
        button.classList.toggle(SELECTED_CLASS, selected);
        button.setAttribute('aria-pressed', String(selected));
      });
    };

    const updateOffer = () => {
      const isPair = pack === 'pair';
      const displayPrice = isPair ? pairPrice : singlePrice;
      if (secondField) secondField.hidden = !isPair;
      if (price) price.textContent = displayPrice;
      if (addButton && !addButton.disabled) {
        addButton.textContent = `ADD TO CART — ${displayPrice}`;
      }
      if (mobileButton) {
        mobileButton.textContent = isPair ? `CHOOSE TWO BOWLS — ${pairPrice}` : `CHOOSE YOUR BOWL — ${singlePrice}`;
      }
    };

    packButtons.forEach((button) => {
      button.addEventListener('click', () => {
        pack = button.dataset.cmPack === 'pair' ? 'pair' : 'single';
        setPressed(packButtons, button);
        updateOffer();
      });
    });

    firstColours.forEach((button) => {
      if (button.dataset.available !== 'true') {
        button.disabled = true;
        button.setAttribute('aria-label', `${button.dataset.name} is sold out`);
      }
      button.addEventListener('click', () => {
        firstColour = button;
        setPressed(firstColours, button);
        if (firstName) firstName.textContent = button.dataset.name || '';
        if (mainImage && button.dataset.image) mainImage.src = button.dataset.image;
        if (imageLabel) imageLabel.textContent = `SELECTED: ${(button.dataset.name || '').toUpperCase()}`;
      });
    });

    secondColours.forEach((button) => {
      if (button.dataset.available !== 'true') {
        button.disabled = true;
        button.setAttribute('aria-label', `${button.dataset.name} is sold out`);
      }
      button.addEventListener('click', () => {
        secondColour = button;
        setPressed(secondColours, button);
        if (secondName) secondName.textContent = button.dataset.name || '';
      });
    });

    root.querySelectorAll('[data-cm-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        if (mainImage && button.dataset.image) mainImage.src = button.dataset.image;
        if (imageLabel) imageLabel.textContent = button.dataset.label || 'PRODUCT DETAIL';
      });
    });

    addButton?.addEventListener('click', async () => {
      if (!firstColour?.dataset.variantId || (pack === 'pair' && !secondColour?.dataset.variantId)) {
        if (status) status.textContent = 'Please choose an available color.';
        return;
      }

      const quantities = new Map();
      quantities.set(firstColour.dataset.variantId, 1);
      if (pack === 'pair') {
        quantities.set(secondColour.dataset.variantId, (quantities.get(secondColour.dataset.variantId) || 0) + 1);
      }
      const items = [...quantities].map(([id, quantity]) => ({ id: Number(id), quantity }));
      const originalLabel = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = 'ADDING…';
      if (status) status.textContent = '';

      try {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${shopRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || 'This selection could not be added.');
        window.location.assign(`${shopRoot}cart`);
      } catch (error) {
        if (status) status.textContent = error.message || 'Something went wrong. Please try again.';
        addButton.disabled = false;
        addButton.textContent = originalLabel;
      }
    });

    updateOffer();
  }

  const initialiseAll = (scope = document) => scope.querySelectorAll('[data-cm-root]').forEach(initialise);
  initialiseAll();
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
